import request from '@/utils/request'

let LeagueApi = {
  categoryIndex(data, errorback) {
    return request._get('/shop/league.category/index', data, errorback);
  },
  categoryAll(data, errorback) {
    return request._get('/shop/league.category/getAll', data, errorback);
  },
  categoryAdd(data, errorback) {
    return request._post('/shop/league.category/add', data, errorback);
  },
  getCategoryEdit(data, errorback) {
    return request._get('/shop/league.category/edit', data, errorback);
  },
  setCategoryEdit(data, errorback) {
    return request._post('/shop/league.category/edit', data, errorback);
  },
  categoryDelete(data, errorback) {
    return request._post('/shop/league.category/delete', data, errorback);
  },


  serviceIndex(data, errorback) {
    return request._get('/shop/league.service/index', data, errorback);
  },
  serviceAll(data, errorback) {
    return request._get('/shop/league.service/getAll', data, errorback);
  },
  serviceAdd(data, errorback) {
    return request._post('/shop/league.service/add', data, errorback);
  },
  setServiceEdit(data, errorback) {
    return request._post('/shop/league.service/edit', data, errorback);
  },
  getServiceEdit(data, errorback) {
    return request._get('/shop/league.service/edit', data, errorback);
  },
  serviceDelete(data, errorback) {
    return request._post('/shop/league.service/delete', data, errorback);
  },


  storeIndex(data, errorback) {
    return request._get('/shop/league.store/index', data, errorback);
  },
  storeAdd(data, errorback) {
    return request._post('/shop/league.store/add', data, errorback);
  },
  setStoreEdit(data, errorback) {
    return request._post('/shop/league.store/edit', data, errorback);
  },
  getStoreEdit(data, errorback) {
    return request._get('/shop/league.store/edit', data, errorback);
  },
  storeDelete(data, errorback) {
    return request._post('/shop/league.store/delete', data, errorback);
  },

  cityAll(data, errorback) {
    return request._get('/shop/city.city/getAll', data, errorback);
  },
  getAddress(data, errorback) {
    return request._get('/shop/location/getAddress', data, errorback);
  },





}
export default LeagueApi;



// WEBPACK FOOTER //
// ./src/api/league.js